// Shared contact band (bottom of both the services page and the home page).
const contactBand = {
  eyebrow: 'Get in touch',
  title: "Let's talk.",
  lead: 'Tell me what you need. Every message reaches me directly.',
  emailMe: 'Email me',
  book: 'Book 30 min',
  directPrefix: 'Or email me directly at',
  githubAria: 'GitHub',
  xAria: 'X (formerly Twitter)',
  linkedinAria: 'LinkedIn',
  wizard: {
    q1Label: 'What brings you here?',
    optAutomate: 'Automate a workflow',
    optBuild: 'Build an AI agent or app',
    optRole: 'Recruitment or a role',
    optOther: 'Something else',
    q2Label: 'Where can I reach you?',
    q2Placeholder: 'you@company.com',
    q3Label: 'And your name?',
    q3Placeholder: 'Your name',
    back: 'Back',
    next: 'Next',
    send: 'Send it',
    sending: 'Sending',
    doneTitle: 'Got it.',
    doneBody: "I'll get back to you within a day.",
    invalidEmail: 'Enter a valid email',
    required: 'This one is needed',
    errorPrefix: 'Something went wrong. Email me at',
    prefer: 'Prefer the classic way?',
  },
};

export default contactBand;
